import type { StepContentConfig } from '../../utils';

export const documentsStepContent: StepContentConfig = {
    mainTitle: {
        site: "Bravo, vous y êtes presque, plus qu'une petite étape...",
    },
    description: {
        site: ['Il ne nous manque plus que vos documents justificatifs pour compléter et finaliser votre dossier !'],
        conseiller: [
            'Il ne nous manque plus que les documents justificatifs de votre client pour compléter et finaliser son dossier !',
            'Un lien de signature électronique a également été envoyé à votre client',
        ],
        conseillermae: ['Un lien de signature électronique a également été envoyé à votre adhérent.'],
    },
    buttonText: {
        site: 'Envoyez vos documents',
        conseiller: 'Envoyez les documents du client',
        conseillermae: "Envoyez les documents de l'adhérent",
    },
};
